import { useState, useEffect } from 'react';
import { BlogPost } from '@/types/blog';
import { getBlogPosts, getBlogPost } from '@/lib/api';
import { useTenant } from './useTenant';

export function useBlogPosts(featured?: boolean) {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { config } = useTenant();
  const companyId = config?.id;

  useEffect(() => {
    async function fetchPosts() {
      // Wait for tenant config to load
      if (!companyId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await getBlogPosts(companyId, featured);
        if (response.success) {
          setPosts(response.data);
        } else {
          setError('Error al cargar posts del blog');
        }
      } catch (err) {
        setError('Error al cargar posts del blog');
      } finally {
        setLoading(false);
      }
    }

    fetchPosts();
  }, [featured, companyId]);

  return { posts, loading, error };
}

export function useBlogPost(slug: string) {
  const [post, setPost] = useState<BlogPost | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { config } = useTenant();
  const companyId = config?.id;

  useEffect(() => {
    async function fetchPost() {
      // Wait for tenant config to load
      if (!companyId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await getBlogPost(slug, companyId);
        if (response.success) {
          setPost(response.data);
        } else {
          setError(response.message || 'Post no encontrado');
        }
      } catch (err) {
        setError('Error al cargar el post');
      } finally {
        setLoading(false);
      }
    }

    if (slug) {
      fetchPost();
    }
  }, [slug, companyId]);

  return { post, loading, error };
}